import { memo } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

import { CounsellingRecord, Option, CounsellingPath } from './types';
import { SUBJECT_DESIGNATIONS } from '../../../shared/services/commonService';

/* eslint-disable @typescript-eslint/no-explicit-any */

interface CounsellingCardProps {
  counList: CounsellingRecord;
  index: number;
  path: CounsellingPath;
  blockList: Option[];
  districtHeader: string;
  districtValue: any;
  disabled: boolean;
  onPanelType: (value: any, index: number) => void;
  onSubject: (value: any, index: number) => void;
  onBlock: (value: any, index: number) => void;
  onStart: (row: CounsellingRecord) => void;
  onReset: (row: CounsellingRecord) => void;
}

/**
 * A single counselling card on the list screen. Extracted and memoized so that
 * changing one card's Panel/Subject/Block dropdown only re-renders that card,
 * not the entire (very large) DEE component — this removes the per-click hang.
 */
const CounsellingCard = ({
  counList,
  index: i,
  path,
  blockList,
  districtHeader,
  districtValue,
  disabled,
  onPanelType,
  onSubject,
  onBlock,
  onStart,
  onReset,
}: CounsellingCardProps) => {
  return (
    <div className="m-3">
      <div className="row">
        <button type="button" className="headingButton">
          {counList.DesignationName} - {counList.FromDate}
        </button>
      </div>
      <div className="row text-center">
        {/* Agenda */}
        <div
          className={
            path === 'seniority'
              ? 'col-lg-3 col-md-12 col-sm-12'
              : 'col-lg-2 col-md-12 col-sm-12'
          }
        >
          <div className="row">
            <div className="col-lg-12 col-md-6 col-sm-6 col-6 heading-row">
              Agenda
            </div>
            <div className="col-lg-12 col-md-6 col-sm-6 col-6 content-row cnt-margin">
              {counList.Title}
            </div>
          </div>
        </div>

        {/* District / Block / Edu district */}
        {path !== 'seniority' && (
          <div className="col-lg-2 col-md-12 col-sm-12">
            <div className="row">
              <div className="col-lg-12 col-md-6 col-sm-6 col-6 heading-row">
                {districtHeader}
              </div>
              <div className="col-lg-12 col-md-6 col-sm-6 col-6 content-row cnt-margin">
                {districtValue}
              </div>
            </div>
          </div>
        )}

        {/* Panel */}
        <div className="col-lg-2 col-md-12 col-sm-12">
          <div className="row">
            <div className="col-lg-12 col-md-6 col-sm-6 col-6 heading-row">
              Panel
            </div>
            <div className="col-lg-12 col-md-6 col-sm-6 col-6 content-row">
              {path !== 'order-copy' &&
              String(counList.CounsellingType) !== '4' ? (
                <span className="dropdownSize">
                  <Dropdown
                    value={counList.PanelType}
                    options={counList.SclPanel}
                    optionLabel="label"
                    dataKey="id"
                    placeholder="Select a panel type"
                    showClear
                    onChange={(e) => onPanelType(e.value, i)}
                  />
                </span>
              ) : (
                <span>-</span>
              )}
            </div>
          </div>
        </div>

        {/* Subject */}
        <div className="col-lg-2 col-md-12 col-sm-12">
          <div className="row">
            <div className="col-lg-12 col-md-6 col-sm-6 col-6 heading-row">
              Subject
            </div>
            <div className="col-lg-12 col-md-6 col-sm-6 col-6 content-row">
              {SUBJECT_DESIGNATIONS.includes(String(counList.Designation)) && (
                <span className="dropdownSize">
                  <Dropdown
                    value={counList.SubjectId}
                    options={counList.Subject}
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select a subject"
                    showClear
                    onChange={(e) => onSubject(e.value, i)}
                  />
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Block */}
        <div className="col-lg-2 col-md-12 col-sm-12">
          <div className="row">
            <div className="col-lg-12 col-md-6 col-sm-6 col-6 heading-row">
              Block
            </div>
            <div className="col-lg-12 col-md-6 col-sm-6 col-6 content-row">
              {((String(counList.Location) === '1' && path !== 'order-copy') ||
                (String(counList.Location) === '1' &&
                  path === 'counseling-reset')) && (
                <span className="dropdownSize">
                  <Dropdown
                    value={counList.BlockId}
                    options={blockList}
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Select a block"
                    showClear
                    onChange={(e) => onBlock(e.value, i)}
                  />
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Actions */}
        <div
          className={
            path === 'seniority'
              ? 'col-lg-3 col-md-12 col-sm-12'
              : 'col-lg-2 col-md-12 col-sm-12'
          }
        >
          <div className="row">
            <div className="col-lg-12 col-md-6 col-sm-6 col-6 heading-row">
              Actions
            </div>
            <div className="col-lg-12 col-md-6 col-sm-6 col-6 content-row cnt-margin">
              <Button
                type="button"
                className="p-button-success"
                label={path ? 'Select' : 'Start'}
                disabled={disabled}
                onClick={() => onStart(counList)}
              />
              &nbsp;
              {/* {String(counList.SeniorityReset) === '1' &&
                path === 'seniority' && (
                  <>
                    <Button
                      type="button"
                      className="p-button-danger"
                      label="Seniority Reset"
                      onClick={() => onReset(counList)}
                    />
                  </>
                )} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(CounsellingCard);

/* eslint-enable @typescript-eslint/no-explicit-any */
